export class ResetPassword {
  public Email: string;
  public Code: string;
  public ConfirmPassword: string;
  public Password: string;
}
